import React from 'react'
import {  Box, Grid, TextField, Select, MenuItem,} from '@mui/material'
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import borderStyle from '../../styles/borderStyle'

// const firstRow = {
//     id: 1,
//     Task_Descrption: "",
//     Bay_Allotted: "",
//     Staff_Allocated: "",
//     Allotted_Date_Time: "",
//     Task_Status: "",
    
// }
const dataGridStyle = {
  root: {
    "& .MuiDataGrid-root": {
      borderRadius: '10px',
      backgroundColor: 'white',
      fontSize: '15px',
    },
    "& .MuiDataGrid-columnHeaders": {
      color: '#005A9C',
      fontSize: '16px',
    }
  },
};
// const boxStyle = {
//     root: {
//       backgroundColor: 'white', 
//       borderRadius: '5px',
//       padding: 1
//     },
//   };


function CustomColumnMenu(props) {
    return (
      
      <GridColumnMenu
        {...props}
        slots={{
       // Hide `columnMenuColumnsItem`
        columnMenuColumnsItem: null,
        columnMenuSortItem: null,
        }}
      />
      
  );
  }

function WorkAllocation() {
    
    const columns = [
    { field: 'id', headerName: ' NO', editable: false, sortable: false },
    { field: 'Task_Descrption', headerName: 'Task Descrption', editable: false, sortable: false, flex: 1.5, minWidth: 100 },
    { field: 'Bay_Allotted', headerName: 'Bay Allotted', editable: false, sortable: false, flex: 1, minWidth: 100,
    renderCell: (params) => (
        <Select
            fullWidth
            variant="outlined"
            style={borderStyle.root}
            value={params.row.Status}
            // onChange={(e) => handleFieldChange(e, params.row.id, 'discType')}
            size="small"
        >
            <MenuItem value="1" > MOT </MenuItem>
            <MenuItem value="2" > Service </MenuItem>
            
        </Select>
    )},
    { field: 'Staff_Allocated', headerName: 'Staff Allocated', editable: false, sortable: false, flex: 1, minWidth: 100 ,
  
    renderCell: (params) => (
        <Select
            fullWidth
            variant="outlined"
            style={borderStyle.root}
            value={params.row.Status}
            // onChange={(e) => handleFieldChange(e, params.row.id, 'discType')}
            size="small"
            
        >
            <MenuItem value="1" > Abdul </MenuItem>
            <MenuItem value="2" > Ali </MenuItem>
            <MenuItem value="3" > Adam </MenuItem>
            <MenuItem value="3" > Amir </MenuItem>
            <MenuItem value="3" > Ahmad </MenuItem>
            <MenuItem value="3" > Rashid </MenuItem>
        </Select>
    )},
    
    { field: 'Allotted_Date_Time', headerName: 'Allotted Date Time', editable: false, sortable: false ,flex: 1, minWidth: 100},
    { field: 'Task_Status', headerName: 'Task Status', editable: false, sortable: false, flex: 1, minWidth: 100,
    renderCell: (params) => (
        <Select
            fullWidth
            variant="outlined"
            style={borderStyle.root}
            // value={params.row.Task_Status}
            // onChange={(e) => handleFieldChange(e, params.row.id, 'discType')}
            size="small"
        >
            <MenuItem value="1" > In Progress </MenuItem>
            <MenuItem value="2" > Completed </MenuItem>
            <MenuItem value="3" > Rejected </MenuItem>
        </Select>
    )},
    
    ]; 
    
    const rows = [
    { id: '1', Task_Descrption: 'Break Adjustment', Bay_Allotted: '', Staff_Allocated: '', Allotted_Date_Time:'05-09-2023 12:25', Task_Status:''},
    { id: '2', Task_Descrption: 'Break Pad Adjustment', Bay_Allotted: '', Staff_Allocated: '', Allotted_Date_Time:'10-09-2023 10:25', Task_Status:''},
    { id: '3', Task_Descrption: 'Full Service', Bay_Allotted: '', Staff_Allocated: '', Allotted_Date_Time:'15-09-2023 11:25', Task_Status:''},
    
    ]; 
                                    
    return (
      <form>
        <Box sx={dataGridStyle.root}>
          <DataGrid
            columnHeaderHeight={30}
            rowHeight={30}
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
            pageSizeOptions={[10]}
            slots={{ columnMenu: CustomColumnMenu }}
            disableRowSelectionOnClick
          />
        </Box>
        <Box sx={dataGridStyle.root}>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={6} mt={1}>
                    <TextField fullWidth size='small' label= 'Suggestion To Mechanic' variant="outlined"required name='Suggestion To Mechanic' inputProps={{style: {height: '50px'}}}  multiline/>
                </Grid> 
                <Grid item xs={12} sm={6} md={6} mt={1}>
                    <TextField fullWidth size='small' label= 'Feedback From Mechanic' variant="outlined"required name='Feedback From Mechanic' inputProps={{style: {height: '50px'}}} multiline />
                </Grid>
        </Grid>
        </Box>
      </form>
    );
}

export default WorkAllocation